import { EventEmitter, Component, forwardRef, Input, Output, NgModule } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { CommonModule } from '@angular/common';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const DEFAULT_COLOR_CHECKED = '#0099CC';
/** @type {?} */
const DEFAULT_COLOR_UNCHECKED = '#e0e0e0';
/** @type {?} */
const DEFAULT_LABEL_CHECKED = '';
/** @type {?} */
const DEFAULT_LABEL_UNCHECKED = '';
/** @type {?} */
const DEFAULT_SWITCH_COLOR = '#fff';
/** @type {?} */
const DISABLED_COLOR = '#dbdbdb';
/** @type {?} */
const DISABLED_BUTTON_COLOR = 'silver';
class NgToggleComponent {
    constructor() {
        this.value = true;
        this.name = '';
        this.disabled = false;
        this.height = 25;
        this.width = 45;
        this.margin = 2;
        this.speed = 300;
        this.labels = true;
        this.checkedLabel = '';
        this.uncheckedLabel = '';
        this.values = { checked: true, unchecked: false };
        this.cssColors = false;
        this.change = new EventEmitter();
        this.onChange = (/**
         * @param {?} _
         * @return {?}
         */
        (_) => { });
        this.onTouch = (/**
         * @return {?}
         */
        () => { });
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.setToogle();
    }
    /**
     * @param {?} value
     * @return {?}
     */
    onInput(value) {
        this.value = value;
        this.onTouch();
        this.onChange(this.value);
    }
    /**
     * @param {?} value
     * @return {?}
     */
    writeValue(value) {
        if (value) {
            this.value = value == true ? this.values.checked : this.values.unchecked;
        }
        else {
            this.value = this.values.unchecked;
        }
    }
    /**
     * @param {?} fn
     * @return {?}
     */
    registerOnChange(fn) {
        this.onChange = fn;
    }
    /**
     * @param {?} fn
     * @return {?}
     */
    registerOnTouched(fn) {
        this.onTouch = fn;
    }
    /**
     * @param {?} isDisabled
     * @return {?}
     */
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
    }
    /**
     * @return {?}
     */
    setToogle() {
        /** @type {?} */
        const value = this.model !== undefined ? this.model : this.value;
        /** @type {?} */
        let index = Object.values(this.values).findIndex((/**
         * @param {?} el
         * @return {?}
         */
        el => el == value));
        if (index > -1)
            this.toggled = Object.keys(this.values)[index] == 'checked' ? true : false;
    }
    /**
     * @return {?}
     */
    get coreStyle() {
        return {
            width: px(this.width),
            height: px(this.height),
            transition: `all ${this.speed}ms`,
            backgroundColor: this.cssColors
                ? null
                : (this.disabled ? this.colorDisabled : this.colorCurrent),
            borderRadius: px(Math.round(this.height / 2))
        };
    }
    /**
     * @return {?}
     */
    get buttonRadius() {
        return this.height - this.margin * 2;
    }
    /**
     * @return {?}
     */
    get distance() {
        return px(this.width - this.height + this.margin);
    }
    /**
     * @return {?}
     */
    get buttonStyle() {
        /** @type {?} */
        const transition = `all ${this.speed}ms`;
        /** @type {?} */
        const margin = px(this.margin);
        /** @type {?} */
        const transform = this.toggled
            ? translate(this.distance, margin)
            : translate(margin, margin);
        /** @type {?} */
        let background = this.switchColor
            ? this.switchColorCurrent
            : null;
        background = this.disabled ? DISABLED_BUTTON_COLOR : background;
        return {
            width: px(this.buttonRadius),
            height: px(this.buttonRadius),
            transition,
            transform,
            background,
        };
    }
    /**
     * @return {?}
     */
    get labelStyle() {
        return {
            lineHeight: px(this.height),
            fontSize: this.fontSize ? px(this.fontSize) : null,
            color: this.fontColor ? this.fontColorCurrent : null
        };
    }
    /**
     * @return {?}
     */
    get colorChecked() {
        let { color } = this;
        if (!isObject(color)) {
            return color || DEFAULT_COLOR_CHECKED;
        }
        return get(color, 'checked', DEFAULT_COLOR_CHECKED);
    }
    /**
     * @return {?}
     */
    get colorUnchecked() {
        return get(this.color, 'unchecked', DEFAULT_COLOR_UNCHECKED);
    }
    /**
     * @return {?}
     */
    get colorDisabled() {
        return get(this.color, 'disabled', DISABLED_COLOR);
    }
    /**
     * @return {?}
     */
    get colorCurrent() {
        return this.toggled
            ? this.colorChecked
            : this.colorUnchecked;
    }
    /**
     * @return {?}
     */
    get labelChecked() {
        return get(this.labels, 'checked', DEFAULT_LABEL_CHECKED);
    }
    /**
     * @return {?}
     */
    get labelUnchecked() {
        return get(this.labels, 'unchecked', DEFAULT_LABEL_UNCHECKED);
    }
    /**
     * @return {?}
     */
    get switchColorChecked() {
        return get(this.switchColor, 'checked', DEFAULT_SWITCH_COLOR);
    }
    /**
     * @return {?}
     */
    get switchColorUnchecked() {
        return get(this.switchColor, 'unchecked', DEFAULT_SWITCH_COLOR);
    }
    /**
     * @return {?}
     */
    get switchColorCurrent() {
        if (!isObject(this.switchColor)) {
            return this.switchColor || DEFAULT_SWITCH_COLOR;
        }
        return this.toggled
            ? this.switchColorChecked
            : this.switchColorUnchecked;
    }
    /**
     * @return {?}
     */
    get fontColorChecked() {
        return get(this.fontColor, 'checked', DEFAULT_SWITCH_COLOR);
    }
    /**
     * @return {?}
     */
    get fontColorUnchecked() {
        return get(this.fontColor, 'unchecked', DEFAULT_SWITCH_COLOR);
    }
    /**
     * @return {?}
     */
    get fontColorCurrent() {
        if (!isObject(this.fontColor)) {
            return this.fontColor || DEFAULT_SWITCH_COLOR;
        }
        return this.toggled
            ? this.fontColorChecked
            : this.fontColorUnchecked;
    }
    /**
     * @param {?} event
     * @return {?}
     */
    toggle(event) {
        /** @type {?} */
        const toggled = !this.toggled;
        this.toggled = toggled;
        this.value = this.getValue(toggled);
        this.onTouch();
        this.onChange(this.value);
    }
    /**
     * @param {?} key
     * @return {?}
     */
    getValue(key) {
        return key === true ? this.values['checked'] : this.values['unchecked'];
    }
}
NgToggleComponent.decorators = [
    { type: Component, args: [{
                selector: 'ng-toggle',
                template: "<label class=\"ng-toggle-switch\">\r\n  <input\r\n    type=\"checkbox\"\r\n    class=\"ng-toggle-switch-input\"\r\n    [name]=\"name\"\r\n    [checked]=\"value\"\r\n    [disabled]=\"disabled\"\r\n    (change)=\"toggle($event)\"\r\n  >\r\n  <div\r\n    class=\"ng-toggle-switch-core\"\r\n    [ngStyle]=\"coreStyle\"\r\n  >\r\n    <div\r\n      class=\"ng-toggle-switch-button\"\r\n      [ngStyle]=\"buttonStyle\">\r\n    </div>\r\n  </div>\r\n  <ng-container *ngIf=\"labels\">\r\n    <span\r\n      class=\"ng-toggle-switch-label ng-toggle-left\"\r\n      [ngStyle]=\"labelStyle\"\r\n      *ngIf=\"toggled\"\r\n    >\r\n      {{labelChecked}}\r\n    </span>\r\n    <span\r\n      class=\"ng-toggle-switch-label ng-toggle-right\"\r\n      [ngStyle]=\"labelStyle\"\r\n      *ngIf=\"!toggled\"\r\n    >\r\n      <ng-container slot=\"unchecked\">\r\n        {{labelUnchecked}}\r\n      </ng-container>\r\n    </span>\r\n  </ng-container>\r\n</label>",
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef((/**
                         * @return {?}
                         */
                        () => NgToggleComponent)),
                        multi: true
                    }
                ],
                styles: [".ng-toggle-switch{display:inline-block;position:relative;vertical-align:middle;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;font-size:10px;cursor:pointer}.ng-toggle-switch .ng-toggle-switch-input{opacity:0;position:absolute;width:1px;height:1px}.ng-toggle-switch .ng-toggle-switch-label{position:absolute;top:0;font-weight:600;color:#fff;z-index:1}.ng-toggle-switch .ng-toggle-switch-label.ng-toggle-left{left:10px}.ng-toggle-switch .ng-toggle-switch-label.ng-toggle-right{right:10px}.ng-toggle-switch .ng-toggle-switch-core{display:block;position:relative;box-sizing:border-box;outline:0;margin:0;transition:border-color .3s,background-color .3s;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.ng-toggle-switch .ng-toggle-switch-core .ng-toggle-switch-button{display:block;position:absolute;overflow:hidden;top:0;left:0;border-radius:100%;background-color:#fff;z-index:2}.ng-toggle-switch.disabled{pointer-events:none;opacity:.6}"]
            }] }
];
/** @nocollapse */
NgToggleComponent.ctorParameters = () => [];
NgToggleComponent.propDecorators = {
    value: [{ type: Input }],
    name: [{ type: Input }],
    disabled: [{ type: Input }],
    height: [{ type: Input }],
    width: [{ type: Input }],
    margin: [{ type: Input }],
    fontSize: [{ type: Input }],
    speed: [{ type: Input }],
    color: [{ type: Input }],
    switchColor: [{ type: Input }],
    labels: [{ type: Input }],
    checkedLabel: [{ type: Input }],
    uncheckedLabel: [{ type: Input }],
    fontColor: [{ type: Input }],
    values: [{ type: Input }],
    model: [{ type: Input, args: ['ngModel',] }],
    change: [{ type: Output }]
};
if (false) {
    /** @type {?} */
    NgToggleComponent.prototype.value;
    /** @type {?} */
    NgToggleComponent.prototype.name;
    /** @type {?} */
    NgToggleComponent.prototype.disabled;
    /** @type {?} */
    NgToggleComponent.prototype.height;
    /** @type {?} */
    NgToggleComponent.prototype.width;
    /** @type {?} */
    NgToggleComponent.prototype.margin;
    /** @type {?} */
    NgToggleComponent.prototype.fontSize;
    /** @type {?} */
    NgToggleComponent.prototype.speed;
    /** @type {?} */
    NgToggleComponent.prototype.color;
    /** @type {?} */
    NgToggleComponent.prototype.switchColor;
    /** @type {?} */
    NgToggleComponent.prototype.labels;
    /** @type {?} */
    NgToggleComponent.prototype.checkedLabel;
    /** @type {?} */
    NgToggleComponent.prototype.uncheckedLabel;
    /** @type {?} */
    NgToggleComponent.prototype.fontColor;
    /** @type {?} */
    NgToggleComponent.prototype.values;
    /** @type {?} */
    NgToggleComponent.prototype.model;
    /** @type {?} */
    NgToggleComponent.prototype.cssColors;
    /** @type {?} */
    NgToggleComponent.prototype.change;
    /** @type {?} */
    NgToggleComponent.prototype.toggled;
    /** @type {?} */
    NgToggleComponent.prototype.onChange;
    /** @type {?} */
    NgToggleComponent.prototype.onTouch;
}
/** @type {?} */
const isObject = (/**
 * @param {?} value
 * @return {?}
 */
(value) => {
    return typeof value === 'object';
});
/** @type {?} */
const has = (/**
 * @param {?} object
 * @param {?} key
 * @return {?}
 */
(object, key) => {
    return isObject(object) && object.hasOwnProperty(key);
});
/** @type {?} */
const get = (/**
 * @param {?} object
 * @param {?} key
 * @param {?} defaultValue
 * @return {?}
 */
(object, key, defaultValue) => {
    return has(object, key) ? object[key] : defaultValue;
});
/** @type {?} */
const px = (/**
 * @param {?} value
 * @return {?}
 */
value => {
    return `${value}px`;
});
/** @type {?} */
const translate = (/**
 * @param {?} x
 * @param {?} y
 * @return {?}
 */
(x, y) => {
    return `translate(${x}, ${y})`;
});

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class NgToggleModule {
}
NgToggleModule.decorators = [
    { type: NgModule, args: [{
                declarations: [NgToggleComponent],
                imports: [
                    CommonModule
                ],
                exports: [NgToggleComponent]
            },] }
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { NgToggleModule, NgToggleComponent as ɵa };
//# sourceMappingURL=ng-toggle-button.js.map
